import React, {useState} from 'react';
import Expenses from './Expenses/Expenses';
import './App.css';
import NewExpenses from './Component/NewExpenses';


const dummyExpenses = [
  {id:0, title:"A book", amount:29.8, date: new Date(2021, 2, 23)},
  {id:0, title:"A pen", amount:29.8, date: new Date(2019, 2, 23)},
  {id:0, title:"An Apple", amount:29.8, date: new Date(2020, 2, 23)},
  
]

function App() {
  const [expenses, setExpenses] = useState(dummyExpenses)

  const getExpenseDataHandler = (data) =>{
    setExpenses(prevState =>{
      return[data, ...prevState]
    })
  } 
  return (
    
    <div className="App">
      <div className="App-header">
        <h2 className='head'>Expense Tracker App</h2>
        <NewExpenses onGetExpenseData={getExpenseDataHandler}/>
        <Expenses expenses={expenses}/>
      </div>
    </div>
  );
}

export default App;
